<template>
  <b-menu>
    <b-menu-list>
      <div class="box-header is-clickable" @click="goToMainMenu()">
        <b-icon
          icon="chevron-left"
          :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
          size="is-medium"
        />
        <label class="has-text-color-7 is-size-6">
          {{ !isReduced ? adminFixedLabel : "" }}
        </label>
      </div>

      <b-menu-item
        v-for="(item, index) of validMenuItemList"
        :key="index"
        :icon="item.icon"
        :active="checkActiveRouter(item)"
        :label="!isReduced ? item.label : item.label.slice(0, 3)"
        class="list-item"
        :data-cy="item.dataCY"
        :to="item.path"
        tag="router-link"
      />
    </b-menu-list>
  </b-menu>
</template>

<script>
import { App, General } from "@/utils/constants";
import { mapGetters } from "vuex";
import { USER_PERMISSIONS as userPermissions } from "@/utils/enumerate";

export default {
  name: "AdminMenu",

  props: {
    isReduced: {
      type: Boolean,
      default: false
    },
    handlerReduce: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isActive: false,
      adminFixedLabel: General.RETURN,
      menuItemList: [
        {
          label: General.OVERVIEW,
          path: "/app/admin",
          dataCY: "adm-general"
        },
        {
          label: General.SUBJECT_PLURAL,
          path: "/app/admin/assuntos-categorias",
          permissions: ["MANAGE_CATEGORY"],
          dataCY: "adm-category"
        },
        {
          label: App.MenuAdm.ADDRESS_LOGOS,
          path: "/app/admin/enderecos-logos",
          permissions: [
            "MANAGE_ADDRESS_ADM",
            "MANAGE_ADDRESS_PART",
            "MANAGE_ADDRESS_CAPACITY"
          ],
          dataCY: "adm-address"
        },
        {
          label: General.MARKERS,
          path: "/app/admin/marcadores",
          query: "isAdmBookmark",
          permissions: [
            "MANAGE_BOOKMARKS_ADM",
            "MANAGE_BOOKMARKS_PART",
            "MANAGE_BOOKMARKS_CAPACITY"
          ],
          dataCY: "adm-bookmarks"
        },
        {
          label: General.DOCUMENT_MODELS,
          path: "/app/admin/modelos",
          permissions: [
            "MANAGE_DOC_MODEL_ADM",
            "MANAGE_DOC_MODEL_PART",
            "MANAGE_DOC_MODEL_UNIT"
          ],
          dataCY: "adm-models"
        },
        {
          label: General.USERS,
          path: "/app/admin/busca-usuario",
          urls: "/app/admin/usuario/\\d+|/app/admin/busca-usuario",
          permissions: [
            "MANAGE_USER_ADM",
            "MANAGE_USER_PART",
            "MANAGE_USER_UNIT"
          ],
          dataCY: "adm-users"
        },
        {
          label: General.MANAGE_UNITY,
          path: "/app/admin/gestao-unidades",
          permissions: ["MANAGE_UNITY"],
          dataCY: "adm-unity"
        },
        {
          label: General.OFFICIAL_MODELS,
          path: "/app/admin/modelos-doe",
          permissions: [
            "MANAGE_DOE_DOC_MODEL_ADM",
            "MANAGE_DOE_DOC_MODEL_PART",
            "MANAGE_DOE_DOC_MODEL_UNIT"
          ],
          dataCY: "adm-official-models"
        },
        {
          label: App.MenuAdm.MIGRATION_PROCESS,
          path: "/app/admin/migracoes",
          permissions: ["MIGRATE_PROCESS_ADM", "MIGRATE_PROCESS_SECTOR"],
          dataCY: "adm-migration"
        },
        {
          label: General.PERMISSIONS,
          path: "/app/admin/permissoes",
          permissions: ["MANAGE_PERMISSIONS"],
          dataCY: "adm-permissions"
        },
        {
          label: General.PROFILES,
          path: "/app/admin/perfis",
          permissions: ["MANAGE_PROFILES"],
          dataCY: "adm-profiles"
        },
        {
          label: App.MenuAdm.MESSAGES_AREA,
          path: "/app/admin/mensagens",
          permissions: ["MANAGE_MESSAGES_ADM"],
          dataCY: "adm-messages"
        },
        {
          label: App.MenuAdm.REPORTS,
          path: "/app/admin/relatorios",
          permissions: [
            "MANAGE_REPORT_ADM",
            "MANAGE_REPORT_PART",
            "MANAGE_REPORT_UNIT"
          ],
          dataCY: "adm-reports"
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
      isContrast: "isContrast"
    }),

    actualRoute() {
      return this.$route.path;
    },

    validMenuItemList() {
      return this.menuItemList.filter(item =>
        !item.permissions
          ? true
          : item.permissions.find(permission =>
              this.hasPermission(userPermissions[permission])
            )
      );
    }
  },

  methods: {
    goToMainMenu() {
      this.handlerReduce(false);
      this.$emit("event-switch-menu", "MAIN");
    },
    checkActiveRouter({ query, path, urls }) {
      const inURL =
        (urls && RegExp(urls).test(this.actualRoute)) ||
        this.actualRoute === path;
      return inURL || (query && Object.hasOwn(this.$route.query, query));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.box-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 10px 0px 0px;
  margin-bottom: 5px;
  gap: 10px;
}
.list-item {
  .item-label {
    color: $blue-oil;
  }
  a {
    &:hover {
      .item-label {
        color: $primary;
      }
    }
  }
}
</style>
